// packages/web/src/api/notification-prefs/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { meNotificationPrefsList } from "../generated/sdk.gen.ts";

export const meNotificationPrefsOptions = () =>
  queryOptions({
    queryKey: ["me", "notification-prefs"],
    queryFn: async () => {
      const { data, error } = await meNotificationPrefsList();
      if (error) throw error;
      if (!data) throw new Error("meNotificationPrefsList returned no data");
      return data;
    },
  });
